import React, { Fragment, useRef } from 'react';
import { ToastProvider } from 'react-toast-notifications';
import { Row, Form } from 'react-bootstrap';
import language from '../../config/es';
//redux
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../redux/store/hooks';
import { findBySocieties } from '../../redux/collectingEntity.duck';
import { findSocieties } from '../../redux/society.duck';
import { findByConcept } from '../../redux/type.duck';
import app from '../../config/application';
import {
  findRawAccounts,
  saveAccount,
  updateAccount,
  deleteAccount,
} from '../../redux/account.duck';
//Session user
import SessionConfig from '../../config/session_config';
//Crud compartido
import {
  useCrudState,
  useCrudLifecycle,
} from '../../components/Crud/crudHooks';
import {
  buildEditColumn,
  fetchRows,
  renderDeleteAction,
  requireSelection,
  requireValues,
  stampRows,
} from '../../components/Crud/crudHelpers';
import {
  RequiredFieldsAlertLegacy,
  SelectField,
  TextField,
} from '../../components/Crud/CrudFields';
import {
  CrudButtons,
  CrudDataTable,
  CrudPage,
  WIDE_TABLE_COLS,
} from '../../components/Crud/CrudLayout';

const Account = () => {
  //#region  variables
  const ref = useRef()
  const dispatch = useAppDispatch();

  const {
    data,
    refreshState,
    updateState,
    viewNotification,
    handleSelectRow,
    initStateDelete,
    reloadWith,
    finishDelete,
  } = useCrudState({
    collectionEntity: { value: 0, label: '', error: '' },
    society: { value: 0, label: '', error: '' },
    typeCurrency: { value: 0, label: '', error: '' },
    showloadingEntity: true,
    showloadingSociety: false,
    showloadingCurrency: false,
    pendingData: false,
    enable: false,
    dataRows: [],
    errors: [],
    columns: [],
    entities: [],
    societies: [],
    Currencies: [],
    selectedRows: [],
    id: null,
    showDelete: false,
    auth: JSON.parse(sessionStorage.getItem('user')),
    account: { value: '', error: '' },
    note: { value: '', error: '' },
  });

  data.dataRows = useSelector((store) => store.accountReducer.accounts);
  data.societies = useSelector((store) => store.societyReducer.societies);
  data.Currencies = useSelector((store) => store.typeReducer.types);
  data.entities = useSelector(
    (store) => store.collectingEntityReducer.cEntities
  );

  //#endregion
  //ciclo de vida ---------------------------------------------------
  useCrudLifecycle(ref, data, () => {
    initColumns();
    void initData();
  });
  //#region handlers
  const handleButtonEdit = (row) => {
    data.id = row.id;
    
    data.typeCurrency={ value: Number.parseInt(row.currency.Id), label: row.currency.name, error: '' };
    data.note.value = row.note;
    data.account.value = row.account;
    refreshState();
  };
  //#endregion
  //#region functions
  const initData = async () => {
    await loadSocieties();
    await loadCurrencies();
    data.enable = true;
    data.showloadingCurrency = true;
    refreshState();
  };
  const loadSocieties = async () => {
    await dispatch(findSocieties(data.auth.id.user.userId));
    data.showloadingSociety = true;
  };
  const loadCurrencies = async () => {
    await dispatch(
      findByConcept(data.auth.id.user.userId, app.data.types.currency)
    );
    updateState(true, 'showloadingType');
  };
  const loadEntities = async () => {
    data.showloadingEntity = false;
    await dispatch(
      findBySocieties(data.auth.id.user.userId, data.society.value)
    );
    updateState(true, 'showloadingEntity');
  };
  const initColumns = () => {
    data.columns = [
      buildEditColumn(handleButtonEdit, {
        name: language.messages.lblFunctions,
        width: '100px',
      }),
      {
        name: language.messages.account.lblAccount,
        sortable: false,
        wrap: true,
        width: '200px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.account}</div>
          </span>
        ),
      },
      {
        name: language.messages.account.lblCurrency,
        sortable: false,
        wrap: true,
        width: '100px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase text-primary small">
              {row.currency.name}
            </div>
          </span>
        ),
      },
      {
        name: language.messages.account.lblNote,
        sortable: false,
        wrap: true,
        width: '300px',
        cell: (row) => (
          <span>
            <div className=" text-uppercase small">{row.note}</div>
          </span>
        ),
      },
    ];
    refreshState();
  };
  const updateSelect = async (value, id) => {
    switch (id) {
      case 'collectionEntity':
        data.collectionEntity = value;
        data.pendingData = true;
        await loadAccounts();
        data.pendingData = false;
        break;
      case 'society':
        data.society = value;
        data.collectionEntity = { value: 0, label: '', error: '', auth: '' };
        data.dataRows = [];
        updateState(false, 'showloadingEntity');
        await loadEntities();
        data.showloadingEntity = true;

        break;
      case 'typeCurrency':
        data.typeCurrency = value;
        break;
      default:
        break;
    }
    initColumns();
    refreshState();
  };
  const clearError = () => {
    data.errors = [];
    data.society.error = '';
    data.collectionEntity.error = '';
    data.typeCurrency.error = '';
    data.note.error = '';
    data.account.error = '';
  };
  const validate = () => {
    clearError();
    requireSelection(data, ['society', 'collectionEntity', 'typeCurrency']);
    requireValues(data, ['account']);

    refreshState();
  };
  const saveData = async () => {
    validate();
    if (data.errors.length === 0) {
      updateState(false, 'enable');
      let json = {
        id: data.id,
        status: 1,
        entity: { collectingEntityId: data.collectionEntity.value },
        currency: { Id: data.typeCurrency.value },
        note: data.note.value,
        account: data.account.value.toUpperCase(),
        userAdmin: sessionStorage.getItem('username'),
        authUser: data.auth.id.user.userId,
        societyId: data.society.value.toUpperCase(),
      };

      let response = '';
      if (data.id === null) {
        response = await dispatch(saveAccount(json));
      } else {
        response = await dispatch(updateAccount(json));
      }

      if (response.messageResponse === undefined) {
        updateState(true, 'pendingData');
        await reloadData();
        cleaningForm();
        viewNotification(
          language.messages.msmRegister.replace('{0}', data.account.value),
          'success'
        );

        updateState(false, 'pendingData');
      } else {
        updateState(true, 'enable');
        viewNotification(response.messageResponse, 'error');
      }
    }
  };
  const loadAccounts = async () => {
    updateState(true, 'pendingData');
    data.dataRows = await fetchRows(
      () =>
        dispatch(
          findRawAccounts(data.auth.id.user.userId, data.collectionEntity.value)
        ),
      viewNotification
    );

    updateState(false, 'pendingData');
  };
  const reloadData = () => reloadWith(loadAccounts);
  const disableData = async () => {
    if (data.selectedRows.length > 0) {
      stampRows(data.selectedRows, { authUser: data.auth.id.user.userId });
      initStateDelete(false);

      let response = await dispatch(deleteAccount(data.selectedRows));
      finishDelete(response.code === undefined, response.message, reloadData);
    }
  };
  const reloadDataEnable = () => {
    void loadAccounts();
  };
  const onChange = (event) => {
    switch (event.target.name) {
      case 'account':
        data.account.value = event.target.value;
        data.account.error = '';
        break;
      case 'note':
        data.note.value = event.target.value;
        data.note.error = '';
        break;

      default:
        break;
    }
    refreshState();
  };
  const cleaningForm = () => {
    console.log(123);
    clearForm();
    clearError();
  };
  const clearForm = () => {
    data.id = null;
    data.note.value = '';
    data.account.value = '';
    refreshState();
  };
  const contextActions = renderDeleteAction(disableData, data.enable);
  //#endregion
  return (
    <Fragment>
    <SessionConfig ref={ref}/>
      <CrudPage
        {...WIDE_TABLE_COLS}
        formTitle={language.messages.account.title}
        form={
          <Form autoComplete="off">
            <RequiredFieldsAlertLegacy />
            <Row>
              <SelectField
                col={{ md: 6 }}
                label={language.messages.society.title_society}
                loading={data.showloadingSociety}
                isDisabled={data.id !== null}
                name="society"
                options={data.societies}
                className="text-uppercase small text-primary"
                field={data.society}
                showAuth
                onChange={updateSelect}
                changeKey="society"
              />
              <SelectField
                col={{ md: 6 }}
                label={language.messages.titleCEntityForm}
                loading={data.showloadingEntity}
                isDisabled={data.id !== null}
                name="collectionEntity"
                options={data.entities}
                className="text-uppercase small text-primary"
                field={data.collectionEntity}
                showAuth
                onChange={updateSelect}
                changeKey="collectionEntity"
              />
            </Row>
            <Row>
              <SelectField
                col={{ md: 6 }}
                label={language.messages.account.lblCurrency}
                loading={data.showloadingCurrency}
                name="typeCurrency"
                options={data.Currencies}
                className="text-uppercase small text-primary"
                field={data.typeCurrency}
                onChange={updateSelect}
                changeKey="typeCurrency"
              />
              <TextField
                col={{ md: 6 }}
                label={language.messages.account.lblAccount}
                name="account"
                field={data.account}
                onChange={onChange}
              />
            </Row>
            <TextField
              row
              col={{ md: 12 }}
              label={language.messages.account.lblNote}
              required={false}
              name="note"
              field={data.note}
              onChange={onChange}
            />
            <CrudButtons
              data={data}
              withLoading
              primary
              small={false}
              reloadIcon="fa-refresh"
              onSave={saveData}
              onClear={cleaningForm}
              onReload={reloadDataEnable}
            />
          </Form>
        }
        tableTitle={language.messages.account.title_register}
        table={
          <CrudDataTable
            data={data}
            title={
              language.messages.titleCEntityForm +
              ': ' +
              data.collectionEntity.label
            }
            rows={data.dataRows}
            scrollHeight="500px"
            onSelect={handleSelectRow}
            actions={contextActions}
          />
        }
      />
    </Fragment>
  );
};

const App = () => (
  <ToastProvider>
    <Account />
  </ToastProvider>
);
export default App;
